import React, { Component } from 'react';
import {BrowserRouter as Router, Route, Link} from 'react-router-dom'
import { Form, Button } from 'semantic-ui-react';
import moment from 'moment';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import Navbar_main from '../navbar/navbar_main.jsx'
import axios from 'axios';
import styles from './search.scss';
import "react-datepicker/dist/react-datepicker.css";


//import { MovieList as MovieListCss, MovieListHeader, Container } from './MovieList.module.scss'

class Search extends Component {
  constructor() {
    super();
    this.state = {
      location: '',
      startDate: new Date(),
      endDate: new Date()
    };
    this.startdateChange = this.startdateChange.bind(this);
    this.enddateChange = this.enddateChange.bind(this);
    this.inputHandler = this.inputHandler.bind(this);
  }

  startdateChange(date) {
    this.setState({
      startDate: date
    });
  }

  enddateChange(date) {
    this.setState({
      endDate: date
    });
  }


  inputHandler(event) {
    var val = event.target.value;
    this.setState({
      location: val
    });
  }

  render() {

    return (
      <div>
        <Navbar_main />
        <div className='searchBackground'>
          <div className='form_container'>
            <Form className='searchForm'>
              <Form.Field className='abc_0'>
                <label>WHERE</label>
                <input className='place_input' placeholder='PLEASE ENTER THE CITY' value={this.state.location} onChange={this.inputHandler}/>
              </Form.Field>
              <Form.Group>
                <Form.Field className='abc'>
                  <label>CHECK-IN DATE</label>
                  <DatePicker className="dpicker" selected={this.state.startDate} onChange={this.startdateChange}/>
                </Form.Field>
                <Form.Field className='abc'>
                  <label>CHECKOUT DATE</label>
                  <DatePicker className="dpicker" selected={this.state.endDate} onChange={this.enddateChange}/>
                </Form.Field>
              </Form.Group>
              <div>
                <Link to={'/house?location=' + this.state.location + '&start=' + moment(this.state.startDate).format('YYYY/MM/DD') + '&end=' + moment(this.state.endDate).format('YYYY/MM/DD')}>
                  <Button className='search-button' onClick={this.routeChange}>SEARCH</Button>
                </Link>
              </div>
            </Form>
          </div>
          <div className='bk'></div>
        </div>
      </div>
    );
  }
}


export default Search;
